import { type AddressTypeEnum } from './AddressTypes'
import { formatFullAddress } from '../../../utils/formatFullAddress'
import {
  type PrimaryCategoryConstructor,
  type PrimaryCategory,
} from '../PrimaryCategory'

export interface AddressConstructorData {
  id: number
  name: string
  isActive: boolean
  addressType: AddressTypeEnum
  primaryCategory: Nullable<PrimaryCategoryConstructor['id']>
  addressLineOne: string
  addressLineTwo: string
  city: string
  country: string
  postalCode: string
  stateProvince: string
}

export class Address {
  id: number
  name: string
  isActive: boolean
  addressType: AddressTypeEnum
  primaryCategory: Nullable<PrimaryCategory['id']>
  addressLineOne: string
  addressLineTwo: string
  city: string
  country: string
  postalCode: string
  stateProvince: string

  constructor(data: AddressConstructorData) {
    this.id = data.id
    this.name = data.name
    this.isActive = data.isActive
    this.addressType = data.addressType
    this.primaryCategory = data.primaryCategory ?? null
    this.addressLineOne = data.addressLineOne
    this.addressLineTwo = data.addressLineTwo
    this.city = data.city
    this.country = data.country
    this.postalCode = data.postalCode
    this.stateProvince = data.stateProvince
  }

  get fullAddress(): string {
    return formatFullAddress(
      this.addressLineOne,
      this.addressLineTwo,
      this.city,
      this.stateProvince,
      this.postalCode,
      this.country
    )
  }
}
